export default "__VITE_ASSET__63241c68__"